// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2T5bU","content":"styles_content__3mtFM","selectAll":"styles_selectAll__1Q9CD"};